import { formatNumeric } from '@common/utils'

const Home = ({ dadesCMS }) => {
	return (
		<div className='content' id='grossa_diada'>
			<div className='cap'>
				<p className='l1 up'>La Grossa de la Diada</p>
			</div>
			<div className='premis'>
				<div className='premi premi1'>
					<p className='l2'>Primer premi especial</p>
					<p className='l3'>2.000.000€</p>
					<ul className='p1'>
						<li className='l4'>{formatNumeric(dadesCMS?.primer_premi)}</li>
						<li className='l3'>Sèrie {dadesCMS?.serie}</li>
					</ul>
				</div>
				<div className='premi premi2'>
					<p className='l2'>Primer premi</p>
					<p className='l3'>50.000€</p>
					<ul className='p1'>
						<li className='l4'>{formatNumeric(dadesCMS?.primer_premi)}</li>
					</ul>
				</div>
				<div className='premi premi3'>
					<p className='l2'>Segon premi</p>
					<p className='l3'>20.000€</p>
					<ul className='p1'>
						<li className='l4'>{formatNumeric(dadesCMS?.segon_premi)}</li>
					</ul>
				</div>
				<div className='premi premi3'>
					<p className='l2'>Tercer premi</p>
					<p className='l3'>10.000€</p>
					<ul className='p1'>
						<li className='l4'>{formatNumeric(dadesCMS?.tercer_premi)}</li>
					</ul>
				</div>
				<div className='premi premi5'>
					<p className='l2'>2n reintegrament</p>
					<p className='l3'>5€</p>
					<ul className='p1'>
						<li className='l4'>{formatNumeric(dadesCMS?.segon_reintegrament)}</li>
					</ul>
				</div>
			</div>
		</div>
	)
}

export default Home
